import { Card, Select, Tabs } from "antd";
import { useDispatch } from "react-redux";
import { Sticky, StickyContainer } from "react-sticky";
import { GET_FACILITY_SUCCESS } from "redux/constants/MyM";
import Covid from "./covid";
import PoliceStatement from "./police";
import StatmentVaccination from "./vaccination";

const { Option } = Select;
const { TabPane } = Tabs;

const facilitySuccess = (data) => {
  return {
    type: GET_FACILITY_SUCCESS,
    payload: data,
  };
};

const Statment = () => {
  const dispatch = useDispatch();

  const renderTabBar = (props, DefaultTabBar) => <Sticky bottomOffset={80}>{({ style }) => <DefaultTabBar {...props} style={{ ...style, zIndex: 1, background: "#fff" }} />}</Sticky>;

  const changeTab = (activeKey) => {
    dispatch(facilitySuccess([]));
  };

  return (
    <Card>
      <StickyContainer>
        <Tabs destroyInactiveTabPane renderTabBar={renderTabBar} defaultActiveKey="1" onChange={changeTab}>
          <TabPane tab="Flu Vaccination Statement" key="1">
            <StatmentVaccination />
          </TabPane>
          <TabPane tab="Covid Vaccination Statement" key="2">
            <Covid />
          </TabPane>
          <TabPane tab="Police Check Obligation Statement" key="3">
            <PoliceStatement />
          </TabPane>
        </Tabs>
      </StickyContainer>
    </Card>
  );
};

export default Statment;
